import { InboxPivotDisplayProperties } from '../store/schema/InboxPivotDisplayProperties';
import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';
import { MailIcons } from 'owa-mail-icons';
import { ControlIcons } from 'owa-addins-icons';

export default function getInboxPlusPivotDisplayProperties(
    pivotType: InboxClassificationFilter
): InboxPivotDisplayProperties {
    //TODO: VSO 40597 -- Inbox Plus Loc strings

    switch (pivotType) {
        case InboxClassificationFilter.None:
            return {
                displayText: 'All',
                icon: ControlIcons.Inbox,
            };
        case InboxClassificationFilter.Focused:
            return {
                displayText: 'Focused',
                icon: MailIcons.InboxCheck,
            };
        case InboxClassificationFilter.Promotions:
            return {
                displayText: 'Promotions',
                icon: MailIcons.ShoppingCart,
            };
        case InboxClassificationFilter.Social:
            return {
                displayText: 'Social',
                icon: ControlIcons.Like,
            };
        case InboxClassificationFilter.Newsletters:
            return {
                displayText: 'Newsletters',
                icon: MailIcons.News,
            };
        case InboxClassificationFilter.Other:
            return {
                displayText: 'Other',
                icon: MailIcons.MailLowImportance,
            };
        default:
            return null;
    }
}
